import { GET_MODALITY_OPTIONS } from "../actions/patientAction"


const getModalityOptionsReducer = (state = [], { type,  payload = [] }) => {
  switch (type) {
    case GET_MODALITY_OPTIONS:
      return getOptionFilter(payload)
    default:
      return state
  }
}
  
export default getModalityOptionsReducer

const getOptionFilter = (data)=>{
  let option = {}
  if(data){
    data.map(item => {
    let deviceOption = {}
        deviceOption = {
        [item.type_modality] :{
          label: item.type_modality,
          value: item.type_modality
        }
      }
    option = {
      ...option,
      ...deviceOption
    }
    return option
  })
  }
  return option
}